<div class="sidebar-wrapper d-flex flex-column h-100">
  <aside class="client-sidebar d-flex flex-column h-100 border-0 border-opacity-50 px-3 px-lg-4 py-4">
    <div v-if="uses_case_owner_sidebar" class="sidebar-content flex-grow-1 d-flex flex-column">
      <section class="case-owner-profile-card rounded-4 border p-3">
        <div class="d-flex align-items-start gap-3">
          <div class="case-owner-avatar rounded-circle d-inline-flex align-items-center justify-content-center fw-bold flex-shrink-0">
            {{ case_owner_profile.initials }}
          </div>

          <div class="min-w-0 flex-grow-1">
            <div class="case-owner-name fw-semibold text-truncate">{{ case_owner_profile.name }}</div>
            <div class="case-owner-meta text-uppercase text-truncate">
              {{ sidebar_meta_line || 'USER - WORKSPACE' }}
            </div>
          </div>
        </div>

        <div class="case-owner-metrics row g-0 text-center">
          <div v-for="metric in case_owner_profile.metrics" :key="metric.label" class="col-4">
            <div class="case-owner-metric-value">{{ metric.value }}</div>
            <div class="case-owner-metric-label text-uppercase">{{ metric.label }}</div>
          </div>
        </div>

        <button
          type="button"
          class="case-owner-profile-link d-flex align-items-center justify-content-between text-decoration-none border-0 bg-transparent w-100 px-0 text-start"
          @click="open_case_owner_profile_modal"
        >
          <span>View profile</span>
          <i class="bi bi-chevron-right"></i>
        </button>
      </section>

      <nav class="entity-sidebar case-owner-sidebar-nav mt-4">
        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY WORK</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in case_owner_work_items" :key="item.id">
              <router-link
                :to="{ name: item.route_name }"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-nav-link"
                :class="{ active: is_active_route(item.route_name) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span>{{ item.label }}</span>
                </span>
                <span v-if="item.count" class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>

        <section class="mb-4">
          <div class="sidebar-role-block pb-2">
            <div class="sidebar-role-meta fw-semibold">MY CASES - BY STATUS</div>
          </div>

          <ul class="nav flex-column gap-1">
            <li v-for="item in case_owner_status_items" :key="item.id">
              <router-link
                :to="{ name: item.route_name }"
                class="nav-link d-flex align-items-center justify-content-between fw-semibold case-owner-status-link"
                :class="{ active: is_active_route(item.route_name) }"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3">
                  <span class="case-owner-status-dot rounded-circle" :class="item.dot_class"></span>
                  <span>{{ item.label }}</span>
                </span>
                <span class="case-owner-count-badge">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </section>
      </nav>

      <CaseOwnerProfileModal
        :visible="show_case_owner_profile_modal"
        :profile="case_owner_profile"
        @close="close_case_owner_profile_modal"
        @edit-profile="handle_case_owner_profile_edit"
      />
    </div>

    <div v-else class="sidebar-content admin-sidebar-shell flex-grow-1 d-flex flex-column py-3">
      <div>
        <section class="admin-sidebar-brand">
          <img
            v-if="$clientLogo"
            :src="$clientLogo"
            alt="Client logo"
            class="admin-sidebar-logo img-fluid"
          >
          <div v-else class="min-w-0">
            <div class="admin-sidebar-title text-truncate">{{ sidebar_identity_title }}</div>
            <div class="admin-sidebar-subtitle">{{ sidebar_identity_subtitle }}</div>
          </div>
        </section>

        <button
          type="button"
          class="admin-sidebar-primary-action text-x btn w-100 border-0 fw-semibold mt-3 me-1"
          @click="go_to_sidebar_primary_action"
        >
          <i class="bi bi-box-arrow-in-down me-2"></i>{{ sidebar_primary_action_label }}
        </button>
      </div>

      <nav class="entity-sidebar admin-sidebar-nav mt-4 flex-grow-1">
        <template v-for="group in sidebar_groups" :key="group.id">
          <div class="sidebar-role-block px-0 pb-2">
            <div class="admin-sidebar-section-title fw-semibold">{{ group.label || sidebar_meta_line || 'WORKSPACE' }}</div>
          </div>

          <ul class="nav flex-column gap-2">
            <li v-for="item in group.items" :key="item.id">
              <router-link
                :to="{ name: item.route_name }"
                class="nav-link admin-sidebar-link d-flex align-items-center justify-content-between fw-semibold"
                active-class="active"
                @click="close_sidebar"
              >
                <span class="d-flex align-items-center gap-3 min-w-0">
                  <i :class="['bi', item.icon, 'fs-6']"></i>
                  <span class="text-truncate">{{ item.label }}</span>
                </span>
                <span v-if="item.count !== null && item.count !== undefined" class="admin-sidebar-link-count">{{ item.count }}</span>
              </router-link>
            </li>
          </ul>
        </template>
      </nav>
    </div>

    <div class="pt-4 mt-auto border-top admin-sidebar-footer">
      <button
        type="button"
        class="nav-link nav-item p-0 border-0 bg-transparent admin-sidebar-signout"
        @click="sign_out"
      >
        <i class="bi bi-box-arrow-right fs-5 me-2"></i> Sign Out
      </button>
    </div>
  </aside>
</div>
